import { environment } from '../../../environments/environment';

export function getApiBase(): string {
  return environment.apiUrl;
}
